import React, {useEffect} from "react";
import {detectAnyAdblocker} from 'just-detect-adblock'


import Header from "./partials/Header";
import Introduction from "./components/Introduction";
import Section01 from "./components/Section01";
import Section02 from "./components/Section02";
import Section03 from "./components/Section03";
import Sources from "./components/Sources";
import SizeSVG from "./SizeSVG";
import Footer from "./partials/Footer";
import isMobile from "ismobilejs";

function App() {
    useEffect(() => {

        detectAnyAdblocker().then(detected => {
            if (detected) {
                const adButtons = document.querySelectorAll('[href*="https://ad.doubleclick.net/"]')
                const newUrl = 'https://go.etoro.com/fr/smart-future/driverless?utm_medium=Media&utm_source=109189&utm_content=0&utm_serial=&utm_campaign=&utm_term=&dclid=CjgKEAiAxJSPBhDpmNndxO3UoVYSJAD4dS84eMOWbn1J6UP0ByF9XqlhJ3yn06rM-7EqFf9WrAlDhfD_BwE';

                Object.values(adButtons).map(button => button.href = newUrl)
            }
        });
    }, []);

    useEffect(() => {
        if (!isMobile().phone || window.outerWidth > 800) {
            const svgs = document.querySelectorAll('svg');

            Object.values(svgs).map(svg => SizeSVG(svg))
        }
    }, []);

    return (
        <main className="App">
            <Header/>

            <Introduction/>

            <Section01/>

            <Section02/>

            <Section03/>

            <Sources/>

            <Footer/>
        </main>
    );
}

export default App;
